import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import MetricCard from '../components/MetricCard';
import { Users, Star, Gem, TrendingDown, Download, CheckCircle, Clock, Activity } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Mock data - Utilizzo app ultimi 7 giorni
const appUsageData7Days = [{
  day: 'Lun',
  users: 245
}, {
  day: 'Mar',
  users: 312
}, {
  day: 'Mer',
  users: 289
}, {
  day: 'Gio',
  users: 356
}, {
  day: 'Ven',
  users: 398
}, {
  day: 'Sab',
  users: 421
}, {
  day: 'Dom',
  users: 378
}];
const appUsageData30Days = [{
  day: '1',
  users: 245
}, {
  day: '5',
  users: 312
}, {
  day: '10',
  users: 289
}, {
  day: '15',
  users: 356
}, {
  day: '20',
  users: 398
}, {
  day: '25',
  users: 421
}, {
  day: '30',
  users: 378
}];
const appUsageData90Days = [{
  day: 'Gen',
  users: 2450
}, {
  day: 'Feb',
  users: 2780
}, {
  day: 'Mar',
  users: 2890
}];
// Mock data - Punti raccolti per periodo
const pointsData7Days = [{
  day: 'Lun',
  stella: 12500,
  diamante: 4200
}, {
  day: 'Mar',
  stella: 15600,
  diamante: 5100
}, {
  day: 'Mer',
  stella: 14200,
  diamante: 4800
}, {
  day: 'Gio',
  stella: 17800,
  diamante: 6200
}, {
  day: 'Ven',
  stella: 19900,
  diamante: 7100
}, {
  day: 'Sab',
  stella: 21100,
  diamante: 7800
}, {
  day: 'Dom',
  stella: 18900,
  diamante: 6900
}];
const pointsData30Days = [{
  day: '1',
  stella: 45000,
  diamante: 18000
}, {
  day: '5',
  stella: 52000,
  diamante: 21000
}, {
  day: '10',
  stella: 48000,
  diamante: 19500
}, {
  day: '15',
  stella: 56000,
  diamante: 23000
}, {
  day: '20',
  stella: 61000,
  diamante: 25500
}, {
  day: '25',
  stella: 58000,
  diamante: 24000
}, {
  day: '30',
  stella: 63000,
  diamante: 26500
}];
const pointsData90Days = [{
  day: 'Gen',
  stella: 450000,
  diamante: 180000
}, {
  day: 'Feb',
  stella: 520000,
  diamante: 210000
}, {
  day: 'Mar',
  stella: 580000,
  diamante: 240000
}];
// Mock data - Top Users (più attivi)
const topUsers = [{
  id: 1,
  avatar: 'https://i.pravatar.cc/150?img=1',
  nome: 'Marco Rossi',
  puntiStella: 1250,
  puntiDiamante: 450,
  attivita: 87
}, {
  id: 2,
  avatar: 'https://i.pravatar.cc/150?img=2',
  nome: 'Giulia Bianchi',
  puntiStella: 2340,
  puntiDiamante: 890,
  attivita: 92
}, {
  id: 3,
  avatar: 'https://i.pravatar.cc/150?img=5',
  nome: 'Lorenzo Colombo',
  puntiStella: 3120,
  puntiDiamante: 1240,
  attivita: 95
}, {
  id: 4,
  avatar: 'https://i.pravatar.cc/150?img=6',
  nome: 'Sofia Ricci',
  puntiStella: 2890,
  puntiDiamante: 1050,
  attivita: 89
}, {
  id: 5,
  avatar: 'https://i.pravatar.cc/150?img=9',
  nome: 'Andrea Bruno',
  puntiStella: 2560,
  puntiDiamante: 920,
  attivita: 85
}];
// Mock data - Top Partners (più scelti)
const topPartners = [{
  id: 1,
  nome: 'La Saponaria',
  logo: 'https://blog.lasaponaria.it/hubfs/LaSaponaria-5.jpg',
  riscatti: 234,
  puntiGenerati: 11700
}, {
  id: 2,
  nome: 'EcoStore',
  logo: 'https://i.pravatar.cc/150?img=51',
  riscatti: 187,
  puntiGenerati: 9350
}, {
  id: 3,
  nome: 'GreenLife',
  logo: 'https://i.pravatar.cc/150?img=52',
  riscatti: 156,
  puntiGenerati: 7800
}, {
  id: 4,
  nome: 'BioMarket',
  logo: 'https://i.pravatar.cc/150?img=53',
  riscatti: 142,
  puntiGenerati: 7100
}, {
  id: 5,
  nome: 'NaturaSì',
  logo: 'https://i.pravatar.cc/150?img=54',
  riscatti: 98,
  puntiGenerati: 4900
}];
// Mock data - Prove in attesa di approvazione
const pendingProofs = [{
  id: 1,
  user: 'Marco Rossi',
  avatar: 'https://i.pravatar.cc/150?img=1',
  action: 'Raccolta differenziata',
  puntiStella: 50,
  puntiDiamante: 0,
  data: '2 ore fa',
  immagine: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=400'
}, {
  id: 2,
  user: 'Giulia Bianchi',
  avatar: 'https://i.pravatar.cc/150?img=2',
  action: 'Utilizzo borraccia',
  puntiStella: 30,
  puntiDiamante: 10,
  data: '4 ore fa',
  immagine: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=400'
}, {
  id: 3,
  user: 'Lorenzo Colombo',
  avatar: 'https://i.pravatar.cc/150?img=5',
  action: 'Mobilità sostenibile',
  puntiStella: 0,
  puntiDiamante: 50,
  data: '5 ore fa',
  immagine: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=400'
}];
const CRMDashboard = () => {
  const [usagePeriod, setUsagePeriod] = useState('7days');
  const [pointsPeriod, setPointsPeriod] = useState('7days');
  const getUsageData = () => {
    switch (usagePeriod) {
      case '30days':
        return appUsageData30Days;
      case '90days':
        return appUsageData90Days;
      default:
        return appUsageData7Days;
    }
  };
  const getPointsData = () => {
    switch (pointsPeriod) {
      case '30days':
        return pointsData30Days;
      case '90days':
        return pointsData90Days;
      default:
        return pointsData7Days;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-1647">
      <div className="w-20 flex-shrink-0" data-id="element-1648">
        <Sidebar data-id="element-1649" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1650">
        <Topbar data-id="element-1651" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-1652">
          <PageHeader title="Dashboard CRM" subtitle="Panoramica utenti e attività sulla piattaforma" secondaryAction={{
          label: 'Esporta Report',
          onClick: () => console.log('Export'),
          icon: <Download className="h-4 w-4 mr-2" data-id="element-1654" />
        }} data-id="element-1653" />

          {/* KPI Cards */}
          <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1655">
            <MetricCard title="Utenti Attivi" value="2,847" change="12.5%" isPositive={true} icon={Users} data-id="element-1656" />
            <MetricCard title="Punti Stella Raccolti" value="845,230" change="18.3%" isPositive={true} icon={Star} data-id="element-1657" />
            <MetricCard title="Punti Diamante Raccolti" value="312,450" change="22.7%" isPositive={true} icon={Gem} data-id="element-1658" />
            <MetricCard title="Punti Spesi" value="892,340" change="15.8%" isPositive={true} icon={TrendingDown} data-id="element-1659" />
          </div>

          {/* Charts Row - Utilizzo App and Punti Raccolti */}
          <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-1660">
            {/* Utilizzo App Chart */}
            <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm" data-id="element-1661">
              <div className="flex items-center justify-between mb-4" data-id="element-1662">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-1663">
                  Utilizzo App
                </h3>
                <select className="text-sm border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-greenback" value={usagePeriod} onChange={e => setUsagePeriod(e.target.value)} data-id="element-1664">
                  <option value="7days" data-id="element-1665">Ultimi 7 giorni</option>
                  <option value="30days" data-id="element-1666">Ultimi 30 giorni</option>
                  <option value="90days" data-id="element-1667">Ultimi 3 mesi</option>
                </select>
              </div>
              <div className="h-80" data-id="element-1668">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1669">
                  <BarChart data={getUsageData()} data-id="element-1670">
                    <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1671" />
                    <XAxis dataKey="day" stroke="#6B7280" fontSize={12} data-id="element-1672" />
                    <YAxis stroke="#6B7280" fontSize={12} data-id="element-1673" />
                    <Tooltip contentStyle={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: '0.5rem'
                  }} data-id="element-1674" />
                    <Bar dataKey="users" fill="#108d3e" radius={[4, 4, 0, 0]} data-id="element-1675" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Punti Raccolti Chart */}
            <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm" data-id="element-1676">
              <div className="flex items-center justify-between mb-4" data-id="element-1677">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-1678">
                  Punti Raccolti
                </h3>
                <select className="text-sm border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-greenback" value={pointsPeriod} onChange={e => setPointsPeriod(e.target.value)} data-id="element-1679">
                  <option value="7days" data-id="element-1680">Ultimi 7 giorni</option>
                  <option value="30days" data-id="element-1681">Ultimi 30 giorni</option>
                  <option value="90days" data-id="element-1682">Ultimi 3 mesi</option>
                </select>
              </div>
              <div className="h-80" data-id="element-1683">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1684">
                  <LineChart data={getPointsData()} data-id="element-1685">
                    <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1686" />
                    <XAxis dataKey="day" stroke="#6B7280" fontSize={12} data-id="element-1687" />
                    <YAxis stroke="#6B7280" fontSize={12} data-id="element-1688" />
                    <Tooltip contentStyle={{
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E5E7EB',
                    borderRadius: '0.5rem'
                  }} data-id="element-1689" />
                    <Line type="monotone" dataKey="stella" stroke="#EAB308" strokeWidth={2} dot={{
                    fill: '#EAB308',
                    r: 4
                  }} name="Punti Stella" data-id="element-1690" />
                    <Line type="monotone" dataKey="diamante" stroke="#3B82F6" strokeWidth={2} dot={{
                    fill: '#3B82F6',
                    r: 4
                  }} name="Punti Diamante" data-id="element-1691" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
              <div className="flex items-center justify-center gap-6 mt-4" data-id="element-1692">
                <div className="flex items-center" data-id="element-1693">
                  <Star className="h-4 w-4 text-yellow-500 mr-2" data-id="element-1694" />
                  <span className="text-sm text-gray-600" data-id="element-1695">Punti Stella</span>
                </div>
                <div className="flex items-center" data-id="element-1696">
                  <Gem className="h-4 w-4 text-blue-500 mr-2" data-id="element-1697" />
                  <span className="text-sm text-gray-600" data-id="element-1698">Punti Diamante</span>
                </div>
              </div>
            </div>
          </div>

          {/* Top Users and Top Partners Side by Side */}
          <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-1699">
            {/* Top Users */}
            <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-1700">
              <div className="px-6 py-4 border-b border-gray-200" data-id="element-1701">
                <h3 className="text-lg font-semibold" data-id="element-1702">
                  Top Users (Più Attivi)
                </h3>
              </div>
              <div className="overflow-x-auto" data-id="element-1703">
                <table className="w-full" data-id="element-1704">
                  <thead data-id="element-1705">
                    <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1706">
                      <th className="px-6 py-3" data-id="element-1707">Utente</th>
                      <th className="px-6 py-3" data-id="element-1708">
                        <div className="flex items-center" data-id="element-1709">
                          <Star className="h-3 w-3 mr-1 text-yellow-500" data-id="element-1710" />
                          Stella
                        </div>
                      </th>
                      <th className="px-6 py-3" data-id="element-1711">
                        <div className="flex items-center" data-id="element-1712">
                          <Gem className="h-3 w-3 mr-1 text-blue-500" data-id="element-1713" />
                          Diamante
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-1714">
                    {topUsers.map(user => <tr key={user.id} className="hover:bg-gray-50" data-id="element-1715">
                        <td className="px-6 py-4" data-id="element-1716">
                          <div className="flex items-center" data-id="element-1717">
                            <img src={user.avatar} alt={user.nome} className="h-8 w-8 rounded-full object-cover mr-3" data-id="element-1718" />
                            <div className="font-medium text-gray-900 text-sm" data-id="element-1719">
                              {user.nome}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 font-medium text-yellow-600 text-sm" data-id="element-1720">
                          {user.puntiStella.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 font-medium text-blue-600 text-sm" data-id="element-1721">
                          {user.puntiDiamante.toLocaleString()}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Top Partners */}
            <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-1722">
              <div className="px-6 py-4 border-b border-gray-200" data-id="element-1723">
                <h3 className="text-lg font-semibold" data-id="element-1724">
                  Top Partners (Più Scelti)
                </h3>
              </div>
              <div className="overflow-x-auto" data-id="element-1725">
                <table className="w-full" data-id="element-1726">
                  <thead data-id="element-1727">
                    <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1728">
                      <th className="px-6 py-3" data-id="element-1729">Partner</th>
                      <th className="px-6 py-3" data-id="element-1730">Riscatti</th>
                      <th className="px-6 py-3" data-id="element-1731">Punti</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-1732">
                    {topPartners.map(partner => <tr key={partner.id} className="hover:bg-gray-50" data-id="element-1733">
                        <td className="px-6 py-4" data-id="element-1734">
                          <div className="flex items-center" data-id="element-1735">
                            <img src={partner.logo} alt={partner.nome} className="h-8 w-8 rounded-full object-cover mr-3" data-id="element-1736" />
                            <div className="font-medium text-gray-900 text-sm" data-id="element-1737">
                              {partner.nome}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 font-medium text-sm" data-id="element-1738">
                          {partner.riscatti}
                        </td>
                        <td className="px-6 py-4 font-medium text-greenback text-sm" data-id="element-1739">
                          {partner.puntiGenerati.toLocaleString()}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Prove in Attesa di Approvazione */}
          <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-1740">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1741">
              <div data-id="element-1742">
                <h3 className="text-lg font-semibold" data-id="element-1743">
                  Prove in Attesa di Approvazione
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1744">
                  {pendingProofs.length} prove da verificare
                </p>
              </div>
              <Clock className="h-5 w-5 text-orange-500" data-id="element-1745" />
            </div>
            <div className="divide-y divide-gray-200" data-id="element-1746">
              {pendingProofs.map(proof => <div key={proof.id} className="p-6 hover:bg-gray-50" data-id="element-1747">
                  <div className="flex items-start gap-4" data-id="element-1748">
                    <img src={proof.avatar} alt={proof.user} className="h-12 w-12 rounded-full object-cover" data-id="element-1749" />
                    <div className="flex-1" data-id="element-1750">
                      <div className="flex items-start justify-between" data-id="element-1751">
                        <div data-id="element-1752">
                          <h4 className="font-semibold text-gray-900" data-id="element-1753">
                            {proof.user}
                          </h4>
                          <p className="text-sm text-gray-600 mt-1" data-id="element-1754">
                            {proof.action}
                          </p>
                          <div className="flex items-center gap-3 mt-2" data-id="element-1755">
                            {proof.puntiStella > 0 && <div className="flex items-center text-sm" data-id="element-1756">
                                <Star className="h-4 w-4 mr-1 text-yellow-500" data-id="element-1757" />
                                <span className="font-medium text-yellow-600" data-id="element-1758">
                                  +{proof.puntiStella}
                                </span>
                              </div>}
                            {proof.puntiDiamante > 0 && <div className="flex items-center text-sm" data-id="element-1759">
                                <Gem className="h-4 w-4 mr-1 text-blue-500" data-id="element-1760" />
                                <span className="font-medium text-blue-600" data-id="element-1761">
                                  +{proof.puntiDiamante}
                                </span>
                              </div>}
                            <span className="text-xs text-gray-500" data-id="element-1762">
                              {proof.data}
                            </span>
                          </div>
                        </div>
                        <img src={proof.immagine} alt="Prova" className="h-20 w-20 rounded-lg object-cover" data-id="element-1763" />
                      </div>
                      <div className="flex gap-2 mt-4" data-id="element-1764">
                        <button className="px-4 py-2 bg-greenback text-white rounded-lg text-sm font-medium hover:bg-greenback/90 flex items-center" data-id="element-1765">
                          <CheckCircle className="h-4 w-4 mr-2" data-id="element-1766" />
                          Approva
                        </button>
                        <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50" data-id="element-1767">
                          Rifiuta
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default CRMDashboard;